import React, { useEffect, useRef } from 'react';
import { BlockProps } from '../index.types';
import PageSection from 'components/success-stories/page-section/page-section';
import { Widget } from '@typeform/embed-react';
import { Element } from 'react-scroll';
import { clickEventfromOptions, UA_ID } from 'components/google-analytics/google-analytics';

type UtmProperties = {
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
};

type BlockPropsType = {
    block: BlockProps;
} & {
    title?: string;
    widgetId?: string;
    gaId?: string;
} & UtmProperties;

type IframeSectionType = BlockProps & BlockPropsType;

export default function IframeSectionBlock({ block, ...props }: IframeSectionType) {
    const typeformWrapperRef = useRef<HTMLDivElement>(null);
    const nextQuestionRef = useRef<boolean>(false);

    useEffect(() => {
        function handleMouseOver() {
            if (nextQuestionRef.current) {
                document.body.classList.add('no-scroll');
            }
        }
        function handleMouseOut() {
            if (nextQuestionRef.current) {
                document.body.classList.remove('no-scroll');
            }
        }

        const wrapper = typeformWrapperRef.current;

        wrapper?.addEventListener('mouseover', handleMouseOver);
        wrapper?.addEventListener('mouseout', handleMouseOut);

        return () => {
            wrapper?.removeEventListener('mouseover', handleMouseOver);
            wrapper?.removeEventListener('mouseout', handleMouseOut);
        };
    }, [typeformWrapperRef, nextQuestionRef]);

    return (
        <PageSection
            hasPadding={true}
            hasOnlyTopPadding={true}
            extraClass="page--section-ambassadors-primary"
        >
            <div className="typeform-wrapper" ref={typeformWrapperRef}>
                <Element name="submit-story-iframe">
                    <Widget
                        iframeProps={{
                            id: 'submit-story',
                            title: props.title || 'Bumble Honey Ambassadors form',
                        }}
                        id={props.widgetId || ''}
                        hidden={
                            {
                                utm_source: props.utm_source || 'beehive',
                                utm_medium: props.utm_medium,
                                utm_campaign: props.utm_campaign,
                            } as UtmProperties
                        }
                        enableSandbox={process.env.NODE_ENV !== 'production'}
                        onQuestionChanged={() => {
                            clickEventfromOptions({
                                seoCategory: 'TypeForm Form',
                                seoAction: 'Answer Question',
                                seoLabel: 'Form Question',
                                seoValue: props.widgetId || '',
                            });
                            document.body.classList.add('no-scroll');
                            nextQuestionRef.current = true;
                        }}
                        onEndingButtonClick={() => {
                            clickEventfromOptions({
                                seoCategory: 'TypeForm Form',
                                seoAction: 'Submit Form',
                                seoLabel: 'Form submission',
                                seoValue: props.widgetId || '',
                            });
                        }}
                        // @TODO check if it works - errors in console
                        shareGaInstance={
                            process.env.NODE_ENV === 'production' ? props.gaId || UA_ID : false
                        }
                        style={{
                            height: '85vh',
                            width: '100%',
                        }}
                    />
                </Element>
            </div>
        </PageSection>
    );
}
